module.exports = __webpack_public_path__ + "static/media/smRedCircle.ac3ec5a7.svg";